import { useState } from "react";
import { motion } from "framer-motion";
import { Facebook, Instagram, Twitter, Mail, MessageCircle, Ghost } from "lucide-react";

export const SharePanel = ({ onShare }) => {
  const [earned, setEarned] = useState(0);
  const [copied, setCopied] = useState("");

  const url = window.location.origin;
  const text = "I just locked in my Good Juju pre-order — get yours";
  const encoded = encodeURIComponent(`${text} ${url}`);

  const reward = () => {
    onShare(3);
    setEarned((e) => e + 3);
  };

  const openShare = (href) => {
    window.open(href, "_blank", "noopener");
    reward();
  };

  const copyShare = async (channel) => {
    try {
      await navigator.clipboard.writeText(`${text} ${url}`);
    } catch {}
    setCopied(channel);
    setTimeout(() => setCopied(""), 2000);
    reward();
  };

  const channels = [
    { id: "text", label: "Text", icon: MessageCircle, action: () => openShare(`sms:?&body=${encoded}`) },
    { id: "email", label: "Email", icon: Mail, action: () => openShare(`mailto:?subject=${encodeURIComponent("Good Juju Pre-Order")}&body=${encoded}`) },
    { id: "facebook", label: "Facebook", icon: Facebook, action: () => openShare(`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`) },
    { id: "instagram", label: "Instagram", icon: Instagram, action: () => copyShare("instagram") },
    { id: "snapchat", label: "Snapchat", icon: Ghost, action: () => copyShare("snapchat") },
    { id: "twitter", label: "Twitter", icon: Twitter, action: () => openShare(`https://twitter.com/intent/tweet?text=${encoded}`) },
  ];

  return (
    <motion.div
      data-testid="share-panel"
      className="glass-card mx-auto mt-6 w-full max-w-xl rounded-3xl p-6 text-center sm:p-8"
      initial={{ opacity: 0, y: 30 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
    >
      <h3 className="juju-heading text-xs sm:text-sm">
        Share your pre-order
      </h3>
      <p className="font-tech mt-2 text-[10px] uppercase tracking-[0.25em] text-white/80">
        Get 3 more rolls for every link you share
      </p>
      <div className="mt-6 flex flex-wrap items-center justify-center gap-3">
        {channels.map(({ id, label, icon: Icon, action }) => (
          <button
            key={id}
            data-testid={`share-${id}-btn`}
            onClick={action}
            aria-label={`Share via ${label}`}
            title={copied === id ? "Link copied!" : label}
            className="flex h-12 w-12 items-center justify-center rounded-full bg-white/85 text-[#0B2447] shadow-md transition-all hover:-translate-y-1 hover:bg-white hover:shadow-lg"
          >
            <Icon className="h-5 w-5" />
          </button>
        ))}
      </div>
      <p data-testid="share-feedback" className="font-tech mt-4 min-h-[16px] text-[10px] uppercase tracking-[0.2em] text-white/90">
        {copied ? `Link copied for ${copied} — paste it anywhere` : earned > 0 ? `+${earned} rolls earned` : ""}
      </p>
    </motion.div>
  );
};
